import { Button, Input, Modal } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useMessage } from "../../../../Components/MessageProvider/MessageProvider";
import axiosInstance from "../../../../Components/axiosInstance/AxiosInstance";
import TextArea from "antd/es/input/TextArea";

export default function AddKirimAmmafos({ isModalOpen, setIsModalOpen }) {
  const messageApi = useMessage();

  let [loading, setLoading] = useState();
  let [names, setNames] = useState();

  let [data, setData] = useState({
    name: null,
    date_uborilgan: null,
    date_qabul: null,
    vagon_number: null,
    station: null,
    ttn_number: null,
    tonna: null,
    comment: null,
  });

  const inputRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    // useRef(null),
    // useRef(null),
    // useRef(null),
    // useRef(null),
  ];

  const handleKeyDown = (e, index) => {
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      // Prevent date value from changing
      if (e.target.type === "date") {
        e.preventDefault();
      }
      if (e.key === "ArrowDown") {
        // Focus the next input (if it exists)
        if (index < inputRefs.length - 1) {
          inputRefs[index + 1].current.focus();
        }
      } else if (e.key === "ArrowUp") {
        // Focus the previous input (if it exists)
        if (index > 0) {
          inputRefs[index - 1].current.focus();
        }
      }
    }
  };

  let getNames = async () => {
    try {
      setLoading(true);

      let info = await axiosInstance.get("/api/add-product");

      console.log("info");
      console.log(info);

      if (info.data.success) {
        setNames(info.data.data);
      }
    } catch (error) {
      // getNames();
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  let postKirim = async () => {
    try {
      let { data: info } = await axiosInstance.post(
        "/api/kirim-official?zavod=Ammafos",
        {
          ...data,
        }
      );

      console.log(info);

      if (info.success) {
        setData({
          name: null,
          date_uborilgan: null,
          date_qabul: null,
          vagon_number: null,
          station: null,
          ttn_number: null,
          tonna: null,
          comment: null,
        });
        setIsModalOpen(false);
      }
    } catch (error) {
      // getNames();
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    }
  };

  useEffect(() => {
    getNames();
  }, []);
  return (
    <Modal
      style={{ top: "10px" }}
      title="Mahsulot qo'shish"
      open={isModalOpen}
      //   loading={loadVagon}
      onOk={() => {
        setIsModalOpen(false);
      }}
      onCancel={() => {
        console.log("Modal closed via Cancel button or close icon.");
        setIsModalOpen(false);
      }}
      footer={[
        <Button
          key="back"
          onClick={() => {
            setIsModalOpen(false);
          }}
          style={{ backgroundColor: "#f5222d", color: "#fff" }}
        >
          Tozalash
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={() => {
            postKirim();
          }}
        >
          Saqlash
        </Button>,
      ]}
    >
      {/* <p className="text-[14px] text-[#111827] p-0 m-0 col-span-2">yozdi</p> */}
      <div>
        <label className="text-[16px] block ">Dori nomi</label>
        <select
          id="options"
          onChange={(e) => {
            setData({
              ...data,
              name: e.target.value,
            });
          }}
          value={data.name}
          class="block appearance-none w-full bg-white border border-gray-300 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
        >
          <option value="">Dori turi</option>
          {names
            ? names?.map((el) => {
                return <option value={el.name}>{el.name}</option>;
              })
            : null}
        </select>
        <label className="text-[16px] ">Yuborilgan Sana</label>
        <Input
          type="date"
          placeholder="time"
          value={data.date_uborilgan}
          ref={inputRefs[0]}
          onKeyDown={(e) => {
            handleKeyDown(e, 0);
            if (e.key === "F2") {
              const currentDate = new Date().toISOString().split("T")[0]; // Get current date in YYYY-MM-DD format
              setData({
                ...data,
                date_uborilgan: currentDate,
              });
            }
          }}
          onChange={(e) => {
            console.log(e.target.value);
            setData({
              ...data,
              date_uborilgan: e.target.value,
            });
          }}
        />
        <label className="text-[16px] ">Qabulqilingan Sana</label>
        <Input
          type="date"
          placeholder="time"
          value={data.date_qabul}
          ref={inputRefs[1]}
          onKeyDown={(e) => {
            handleKeyDown(e, 1);
            if (e.key === "F2") {
              const currentDate = new Date().toISOString().split("T")[0]; // Get current date in YYYY-MM-DD format
              setData({
                ...data,
                date_qabul: currentDate,
              });
            }
          }}
          onChange={(e) => {
            console.log(e.target.value);
            setData({
              ...data,
              date_qabul: e.target.value,
            });
          }}
        />
        <label className="text-[16px] ">Vagon raqami </label>
        <Input
          type="text"
          placeholder="Vagon raqami"
          autoFocus={true}
          value={data.vagon_number}
          ref={inputRefs[2]}
          onKeyDown={(e) => {
            handleKeyDown(e, 2);
          }}
          onChange={(e) => {
            // console.log(e.target.value.split("\t"));
            setData({
              ...data,
              vagon_number: e.target.value,
            });
          }}
        />
        <label className="text-[16px] ">Vagzal</label>
        <Input
          type="text"
          placeholder="Vagzal"
          autoFocus={true}
          value={data.station}
          ref={inputRefs[3]}
          onKeyDown={(e) => {
            handleKeyDown(e, 3);
          }}
          onChange={(e) => {
            // console.log(e.target.value.split("\t"));
            setData({
              ...data,
              station: e.target.value,
            });
          }}
        />
        <label className="text-[16px] ">TTN ID</label>
        <Input
          type="text"
          placeholder="TTN ID"
          autoFocus={true}
          value={data.ttn_number}
          ref={inputRefs[4]}
          onKeyDown={(e) => {
            handleKeyDown(e, 4);
          }}
          onChange={(e) => {
            // console.log(e.target.value.split("\t"));
            setData({
              ...data,
              ttn_number: e.target.value,
            });
          }}
        />
        <label className="text-[16px] ">Tonna </label>
        <Input
          type="text"
          placeholder="Yuk miqdori tonnada"
          autoFocus={true}
          value={data.tonna}
          ref={inputRefs[5]}
          onKeyDown={(e) => {
            handleKeyDown(e, 5);
          }}
          onChange={(e) => {
            // console.log(e.target.value.split("\t"));
            setData({
              ...data,
              tonna: e.target.value,
            });
          }}
        />
        <label className="text-[16px] ">Izox </label>

        <TextArea
          rows={4}
          placeholder="Izox yozing"
          autoFocus={true}
          value={data.comment}
          ref={inputRefs[6]}
          onKeyDown={(e) => {
            handleKeyDown(e, 6);
          }}
          onChange={(e) => {
            // console.log(e.target.value.split("\t"));
            setData({
              ...data,
              comment: e.target.value,
            });
          }}
        />
      </div>
    </Modal>
  );
}
